import Divider, { DividerProps } from './Divider';

export default Divider;
export type { DividerProps };
